import state from './oneIDState'
import mutations from './oneIDMutations'
import actions from './oneIDActions'
import getters from './oneIDGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
